export default function ComingSoon() {
    let today = new Date();
    let formattedDate = today.toLocaleDateString();

    return (
        <div className='flex-col flex justify-center items-center h-screen'>
            <h1 className='text-center text-xl font-bold'>
                君の画面幅が大きすぎる😡
            </h1>
            <p className="text-center">
                {formattedDate}
            </p>
        </div>
    );
}
